import { createStore } from 'vuex'

const store = createStore({
  // vuex's strict mode installs a deep *synchronous* watcher over the whole store state — with Vue 3 that walks every
  // hotel/chart record through Proxy traps on each mutation and froze the location pages for minutes in the production
  // build (dev keeps the "do not mutate state outside mutation handlers" assertion).
  strict: process.env.NODE_ENV !== 'production',
  state: {
    locale: document.querySelector('html').getAttribute('lang'),
    localesLoaded: false,
  },
  actions: {
    loadedLocales({ commit }) {
      commit('setLoadedLocales', true);
    },
  },
  mutations: {
    setLoadedLocales(state, value) {
      state.localesLoaded = value;
    },
  },
  getters: {},
  modules: {}
})

export default store
